var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"w-50",attrs:{"src":require("@/assets/XFarmsLogo.png"),"alt":""}}),_c('div',[_c('h2',[_vm._v("An unhandled error occured")]),_c('h4'),_c('router-link',{attrs:{"to":{ name: 'home' },"exact":""}},[_c('h4',[_vm._v("Go back to home page")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }